export enum TextInputColor {
  GRAY = "gray",
  INFO = "info",
  FAILURE = "failure",
  WARNING = "warning",
  SUCCESS = "success",
}
